import { Dependency } from '@iq-solutions/nida-shared/src/question';
import { useContext } from 'react';
import { StepsContext } from '../context/StepsContext';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import PercentageComponent from './percentageComponent';

interface CurrentProps {
  valid: boolean;
  hasSubs: boolean;
  followUp: boolean;
  answer: string;
}

const nextPreviousParse = (props: CurrentProps): JSX.Element => {
  const qContext = useContext(StepsContext);
  const [total, setTotal] = useState<number>(0);
  const options = ['less than monthly', 'monthly', 'weekly', 'daily or almost daily', 'yes'];
  const [done, setDone] = useState(false);
  const [nextData, setNextData] = useState({
    id: 0,
    url: '',
  });

  const doneHandler = (condition: boolean): void => {
    if (condition) {
      setDone(true);
    } else {
      setDone(false);
    }
  };

  const parseNextStep = (): void => {
    let tempNextIndex = qContext.steps?.currentIndexValue! + 1;
    let tempSkipQuestions = [];
    qContext.steps?.setNextIndex(tempNextIndex);
    doneHandler(qContext.steps?.next().done!);

    for (let i = tempNextIndex; i < qContext.steps?.stepsArray.length!; i++) {
      let foundNextStep = false;
      let nextStep = qContext.steps?.next();

      nextStep?.value.questionList[0]?.dependencies.some((nextDep: Dependency): void => {
        if (nextDep.id === '' && nextStep?.value.questions.length === 1) {
          foundNextStep = true;
        } else {
          foundNextStep =
            (nextDep.value === 'Yes' &&
              options.indexOf(qContext.answers[Number(nextDep.id)]?.answer) > -1) ||
            (nextDep.value === '!Never' &&
              options.indexOf(qContext.answers[Number(nextDep.id)]?.answer) > -1)
              ? true
              : false;
        }
      });
      qContext.steps?.setNextIndex(i + 1);

      if (foundNextStep) {
        qContext.nextStep = qContext.steps?.stepsArray[i];
        setNextData({
          id:
            props.hasSubs && props.followUp
              ? qContext.currentStep?.questionList[0].id!
              : qContext.nextStep?.questionList[0].id!,
          url:
            props.hasSubs && props.followUp ? 'secondary' : qContext.nextStep?.questionList[0].url!,
        });
        if (qContext.skippedSteps.indexOf(qContext.steps?.stepsArray[i].questionList[0].id!) > -1) {
          let ind = qContext.skippedSteps.indexOf(
            qContext.steps?.stepsArray[i].questionList[0].id!,
          );
          qContext.skippedSteps.splice(ind, 1);
        }

        break;
      } else {
        tempSkipQuestions.push(nextStep?.value);
      }
      doneHandler(i === qContext.steps?.stepsArray.length! - 1);
    }
    for (const q of tempSkipQuestions) {
      for (const j of q.questions) {
        delete qContext.answers[j.id];
      }
      if (qContext.skippedSteps.indexOf(q.questions[0].id) === -1) {
        qContext.skippedSteps.push(q.questions[0].id);
      }
      if (qContext.completedSteps.indexOf(q.questions[0].id) > -1) {
        qContext.completedSteps.splice(qContext.completedSteps.indexOf(q.questions[0].id), 1);
      }
    }
  };

  for (let i = qContext.steps?.currentIndexValue! - 1; i >= 0; i--) {
    let prevId = qContext.steps?.stepsArray[i]?.questionList[0].id!;
    if (qContext.answers[prevId]) {
      qContext.previousStep = qContext.steps?.stepsArray[i];
      break;
    }
  }

  let prevData = {
    id: qContext.steps?.currentIndexValue !== 0 ? qContext.previousStep?.questionList[0].id : '',
    url: qContext.steps?.currentIndexValue !== 0 ? qContext.previousStep?.questionList[0].url : '',
  };

  useEffect(() => {
    parseNextStep();
    qContext.total = qContext.steps?.stepsArray.length! - qContext.skippedSteps.length;
    setTotal(qContext.steps?.stepsArray.length! - qContext.skippedSteps.length);
  }, [qContext.currentStep, props, qContext.nextStep, props.answer]);

  const nextStepHandler = (): string => {
    if (!done) {
      return qContext?.started ? `/taps2/question/${nextData.id}/${nextData.url}` : '/taps2';
    } else {
      return '/taps2/result/scored';
    }
  };

  return (
    <div className="question-footer">
      <Link
        to={
          qContext.steps?.currentIndexValue! > 0 && qContext.started
            ? `/taps2/question/${prevData.id}/${prevData.url}`
            : '/taps2'
        }
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12m16-1h-8l3.5-3.5l-1.42-1.42L6.16 12l5.92 5.92l1.42-1.42L10 13h8v-2Z"
          />
        </svg>
      </Link>

      <PercentageComponent total={total} doneHandler={doneHandler} />

      {props.valid ? (
        <Link to={nextStepHandler()}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M22 12a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10M6 13h8l-3.5 3.5l1.42 1.42L17.84 12l-5.92-5.92L10.5 7.5L14 11H6v2Z"
            />
          </svg>
        </Link>
      ) : (
        ''
      )}
    </div>
  );
};

export default nextPreviousParse;
